/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

export type Int64 = string | number;

export enum Biz {
  All = 0,
  Open = 1,
  Service = 2,
  Game = 3,
}
/* eslint-enable */
